export const deliveryNotes = {
  title: 'Szállítólevelek',
  subtitle: 'Szállítólevelek kezelése és nyomon követése',
  
  // Alapinformációk
  list: {
    title: 'Szállítólevelek listája',
    empty: 'Nincsenek szállítólevelek',
    loading: 'Szállítólevelek betöltése...',
    error: 'Hiba a szállítólevelek betöltésekor',
    searchPlaceholder: 'Keresés szállítólevél száma, ügyfél neve, email vagy követési szám szerint...',
    createNew: 'Új szállítólevél',
    createNewSoon: 'Új szállítólevél funkció hamarosan!'
  },

  // Táblázat fejlécek
  table: {
    number: 'Szállítólevél száma',
    customer: 'Ügyfél',
    date: 'Szállítási dátum',
    status: 'Státusz',
    amount: 'Összeg',
    tracking: 'Követési szám',
    actions: 'Műveletek'
  },

  // Státuszok
  status: {
    draft: 'Piszkozat',
    pending: 'Függőben',
    shipped: 'Szállítás alatt',
    delivered: 'Kiszállítva',
    confirmed: 'Megerősítve',
    cancelled: 'Törölve'
  },

  // Műveletek
  actions: {
    view: 'Megtekintés',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    updateStatus: 'Státusz frissítése',
    printLabel: 'Címke nyomtatása',
    trackPackage: 'Csomag követése'
  },

  // Statistikák
  stats: {
    total: 'Összes szállítólevél',
    pending: 'Függőben lévő',
    shipped: 'Szállítás alatt',
    delivered: 'Kiszállított'
  },

  // Státusz szűrő
  filter: {
    all: 'Összes',
    draft: 'Piszkozat',
    pending: 'Függőben',
    shipped: 'Szállítás alatt',
    delivered: 'Kiszállítva',
    confirmed: 'Megerősítve',
    cancelled: 'Törölve'
  },

  // Szállítólevél részletek
  details: {
    title: 'Szállítólevél részletei',
    basicInfo: 'Alapinformációk',
    customerInfo: 'Ügyfél információk',
    shippingInfo: 'Szállítási információk',
    items: 'Szállítási tételek',
    notes: 'Megjegyzések',
    systemInfo: 'Rendszer információk',
    documentChain: 'Bizonylat lánc'
  },

  // Szállítólevél szerkesztés
  form: {
    title: 'Szállítólevél szerkesztése',
    status: 'Státusz',
    deliveryDate: 'Szállítási dátum',
    shippingDate: 'Feladás dátuma',
    expectedDeliveryDate: 'Várható kiszállítás',
    deliveryAddress: 'Szállítási cím',
    deliveryInstructions: 'Szállítási utasítások',
    trackingNumber: 'Követési szám',
    carrierName: 'Szállító cég neve',
    shippingMethod: 'Szállítási mód',
    driverName: 'Sofőr neve',
    vehiclePlateNumber: 'Jármű rendszáma',
    notes: 'Megjegyzések',
    save: 'Mentés',
    cancel: 'Mégse',
    required: 'kötelező'
  },

  // Szállítási módok
  shippingMethods: {
    courier: 'Futárszolgálat',
    post: 'Postai küldemény',
    pickup: 'Személyes átvétel',
    ownTransport: 'Saját szállítás',
    express: 'Expressz szállítás'
  },

  // Mezők
  fields: {
    deliveryNoteNumber: 'Szállítólevél száma',
    customerName: 'Ügyfél neve',
    customerEmail: 'Ügyfél email',
    deliveryDate: 'Szállítási dátum',
    shippingDate: 'Feladás dátuma',
    expectedDeliveryDate: 'Várható kiszállítás',
    totalAmount: 'Teljes összeg',
    subtotal: 'Nettó összeg',
    currency: 'Pénznem',
    trackingNumber: 'Követési szám',
    carrierName: 'Szállító cég',
    shippingMethod: 'Szállítási mód',
    driverName: 'Sofőr neve',
    vehiclePlateNumber: 'Jármű rendszáma',
    deliveryAddress: 'Szállítási cím',
    deliveryInstructions: 'Szállítási utasítások',
    createdAt: 'Létrehozva',
    updatedAt: 'Módosítva',
    createdBy: 'Létrehozta'
  },

  // Üzenetek
  messages: {
    statusUpdated: 'Státusz sikeresen frissítve',
    deliveryNoteUpdated: 'Szállítólevél sikeresen frissítve',
    deliveryNoteDeleted: 'Szállítólevél sikeresen törölve',
    confirmDelete: 'Biztosan törli ezt a szállítólevelet?',
    deleteWarning: 'Ez a művelet nem visszavonható!',
    trackingUpdated: 'Követési információ frissítve',
    delivered: 'Csomag sikeresen kiszállítva'
  },

  // Hibák
  errors: {
    loadFailed: 'Hiba a szállítólevelek betöltésekor',
    updateFailed: 'Hiba a szállítólevél frissítésekor',
    deleteFailed: 'Hiba a szállítólevél törlésekor',
    notFound: 'Szállítólevél nem található',
    invalidData: 'Érvénytelen adatok',
    trackingFailed: 'Követési információ lekérése sikertelen'
  }
}; 